<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：会员-积分管理
  -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="余额明细" name="log" v-if="logShow"></el-tab-pane>
      <el-tab-pane label="余额设置" name="settings" v-if="settingsShow"></el-tab-pane>
      <el-tab-pane label="充值套餐" name="plan" v-if="planShow"></el-tab-pane>
      <el-tab-pane label="充值记录" name="record" v-if="recordShow"></el-tab-pane>
      <el-tab-pane label="提现申请" name="cash" v-if="cashShow"></el-tab-pane>

    </el-tabs>

    <!--余额明细-->
    <Log v-if="activeName == 'log'"></Log>
    <!--余额设置-->
    <Setting v-if="activeName == 'settings'"></Setting>
    <!--充值套餐-->
    <Plan v-if="activeName == 'plan'"></Plan>
    <!--充值记录-->
    <Record v-if="activeName == 'record'"></Record>
    <!--提现申请-->
    <Cash v-if="activeName == 'cash'"></Cash>

  </div>
</template>
<script>
import Setting from './part/Setting';
import Log from './part/Log';
import Plan from './part/Plan';
import Record from './part/Record';
import Cash from './part/Cash';
export default {
  components: {
    Setting,
    Log,
    Plan,
    Record,
    Cash
  },
  data() {
    return {
      form: {
        status: 0
      },
      activeName: 'log',
      logShow:true,
      settingsShow:true,
      planShow:true,
      recordShow:true,
      cashShow:true,
    };
  },
  created() {
    if(!this.$filter.isAuth('/user/cash/index')) this.cashShow = false;
    if(!this.$filter.isAuth('/user/balance/log')) this.logShow = false;
    if(!this.$filter.isAuth('/user/balance/setting')) this.settingsShow = false;
    if(!this.$filter.isAuth('/user/plan/index')) this.planShow = false;
    if(!this.$filter.isAuth('/user/plan/log')) this.recordShow = false;
  },
  methods: {}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/user/balance/index.vue